import { Box, Button, TextField } from '@mui/material';
import useRequestStore from '../../../store/request';

export default function RequestDevelopmentInfo({ next, back }) {
  const data = useRequestStore((state) => state.data);

  function handleSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    const data = Object.fromEntries(formData);
    next(data);
  }

  function handleBack(evt) {
    const formData = new FormData(evt.target.closest('form'));
    const data = Object.fromEntries(formData);
    back(data);
  }

  return (
    <Box
      component="form"
      onSubmit={(evt) => handleSubmit(evt)}
      sx={{ display: 'flex', flexFlow: 'column', gap: '16px' }}
    >
      <TextField
        label="Projektbeschreibung"
        name="text"
        multiline
        rows={10}
        required
        defaultValue={data.text}
      />
      <Button
        type="submit"
        variant="contained"
        sx={{
          borderRadius: 0,
          color: 'white',
          boxShadow: 'none !important',
          '&:hover': {
            backgroundColor: '#19BB5D',
          },
        }}
      >
        Weiter
      </Button>
      <Button
        onClick={handleBack}
        name="back"
        variant="text"
        sx={{ mt: '-8px' }}
      >
        Zurück
      </Button>
    </Box>
  );
}
